// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"206":"84030344","272":"efa4a641","390":"45c85769","667":"e5836476","668":"4b7ecf6d"}[chunkId] + ".chunk.css";
};